module.exports = __webpack_public_path__ + "static/media/img_zendy03.ed2ccd86.jpeg";